module.exports = __webpack_public_path__ + "images/agents-forge-section-right.03e8895327174375d5d8e9bad54535e3.png";